import { render, staticRenderFns } from "./sponsored-ads.vue?vue&type=template&id=75164d70&scoped=true"
import script from "./sponsored-ads.vue?vue&type=script&lang=js"
export * from "./sponsored-ads.vue?vue&type=script&lang=js"
import style0 from "./sponsored-ads.vue?vue&type=style&index=0&id=75164d70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75164d70",
  null
  
)

export default component.exports